import * as AlertBarState from '../../components/alert-bar/AlertBar.state';
import * as Nested from '../../utils/Nested';
import { fetchLookupById } from '../products/Products.state';

// Default State
const initialState = {
  error: false,
  isLoading: false,
};

// Action Creators and Action Types
export const ADD_TO_CART_REQUEST = 'ADD_TO_CART_REQUEST';
export const addToCartRequest = (data) => ({
  type: ADD_TO_CART_REQUEST,
  payload: data,
});

export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const addToCartSuccess = (data) => ({
  type: ADD_TO_CART_SUCCESS,
  payload: data,
});

export const ADD_TO_CART_ERROR = 'ADD_TO_CART_ERROR';
export const addToCartError = (data) => ({
  type: ADD_TO_CART_ERROR,
  payload: data,
});

const LOOKUP_ERROR = 'lookup/LOOKUP_ERROR';
export const searchError = (error) => ({
  type: LOOKUP_ERROR,
  payload: { error },
});

// Alert Bar Nested Actions
export const ALERT_BAR_ACTION = 'lookup/ALERT_BAR_ACTION';
export const lookupAlertBarAction = Nested.nestedAction(ALERT_BAR_ACTION);

// Raw Reducer
export const _reducer = (state = initialState, { type /* , payload */ }) => {
  switch (type) {
    case ADD_TO_CART_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ADD_TO_CART_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
      };
    case ADD_TO_CART_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
      };
    case LOOKUP_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
      };
    default:
      return state;
  }
};

// Raw Redux Maps
export const _mapStateToProps = (state) => ({
  ...state.lookup,
});
export const _mapDispatchToProps = (dispatch) => ({
  fetchLookupById: (id) => dispatch(fetchLookupById(id)),
});

// Nested Redux Maps
const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    alertBars: {
      lookupAlertBars: {
        ...AlertBarState,
        actionType: ALERT_BAR_ACTION,
      },
    },
  },
  'lookup',
);

// Nested Reducer
const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
